export default axios => ({
  index(payload = null) {
    return axios.get('admin/event-logs', payload);
  }
})